import getHost from './getHost'
import prependSlashMaybe from './prependSlashMaybe'
import escapeSpecialChar from './escapeSpecialChar'

const mediaServingPath = '/media'

export default path =>
  `${getHost()}${mediaServingPath}${prependSlashMaybe(escapeSpecialChar(encodeURI(path)))}`



// WEBPACK FOOTER //
// ./src/utils/getMediaURL.js